
<app-loader *ngIf="loading"></app-loader>
<div class="checkin">
  <div class="header">
    <div class="title">
      {{"PAGES.MANAGEMENT.CHECKIN_DIALOG.TITLE" | translate}}
      <span (click)="closeDialog()" class="material-icons side-nav-bar-close">clear</span>
    </div>
  </div>
  <div class="body">


    <p class="text-value">
      {{('PAGES.MANAGEMENT.CHECKIN_DIALOG.TEXT.0' | translate)}}
      <br>
      {{('PAGES.MANAGEMENT.CHECKIN_DIALOG.TEXT.1' | translate)}}
    </p>

  </div>
  <div class="footer">
    <button (click)="closeDialog()">
      {{('PAGES.MANAGEMENT.CHECKIN_DIALOG.BACK' | translate) | uppercase }}
    </button>
    <button (click)="handleCheckIn()">
      {{('PAGES.MANAGEMENT.CHECKIN_DIALOG.CONFIRM' | translate) | uppercase }}
    </button>
  </div>
</div>
